import {
  Person as PersonIcon,
  Group as GroupIcon,
  LocalShipping as LocalShippingIcon,
  Apartment as ApartmentIcon,
  Home as HomeIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
} from '@material-ui/icons';
import { ru } from 'locale';

export const icons = {
  GUAR_FIZ: PersonIcon,
  GUAR_YR: GroupIcon,
  FLAT: HomeIcon,
  TRANSPORT: LocalShippingIcon,
  REALTY: ApartmentIcon,
  BANKGUARAN: AccountBalanceWalletIcon,
};

export const tabs = [
  { label: ru.guarantors, value: 'guarantors' },
  { label: ru.properties, value: 'properties' },
];
